import subscriptionPlanActionTypes from '../actions/subscription-plan-action-types';

const initialState = {
  subscriptionPlanRadioSelected: '',
  subscriptionPlansFailed: false,
  subscriptionPlans: [],
  subscriptionProfile: {},
  selectedSubscriptionPlan: {},
  sharesCount: 0,
  discsCount: 0
};

export const subscriptionPlan = (state = initialState, action) => {
  switch(action.type) {
    case subscriptionPlanActionTypes.SET_SELECTED_SUBSCRIPTION_RADIO: {
      const selectedSubscriptionPlan = state.subscriptionPlans.find(subscriptionPlan =>
          subscriptionPlan.product.id === parseInt(action.subscriptionPlanRadioSelected));
      return {...state, subscriptionPlanRadioSelected: action.subscriptionPlanRadioSelected, selectedSubscriptionPlan };
    }
    case subscriptionPlanActionTypes.SUBSCRIPTION_PLANS_FAILED:
      return { ...state, subscriptionPlansFailed: true };
    case subscriptionPlanActionTypes.SUBSCRIPTION_PLANS_RECEIVED:
      return { ...state, subscriptionPlans: action.subscriptionPlans};
    case subscriptionPlanActionTypes.SUBSCRIPTION_PROFILE_RECEIVED:
      return { ...state, subscriptionProfile: action.subscriptionProfile };
    case subscriptionPlanActionTypes.SUBSCRIPTION_PROFILE_FAILED:
      return { ...state, subscriptionProfileFaild: true };
    case subscriptionPlanActionTypes.SUBSCRIPTION_CANCEL_FAILED:
      return { ...state, subscriptionCancelFailed: true };
    case subscriptionPlanActionTypes.SET_SHARES_COUNT:
      return { ...state, sharesCount: action.sharesCount };
    case subscriptionPlanActionTypes.SET_DISCS_COUNT:
      return { ...state, discsCount: action.discsCount };
    default:
      return state;
  }
}


// WEBPACK FOOTER //
// ./src/account/reducers/subscription-plan-reducer.js